<template>
  <div class="superviseArrangeDetail" id="nowPrintDetail">
    <div class="tableRow" v-for="(item, index) in detailList" :key="index">
      <div class="tableLeft">{{ item.name }}</div>
      <div class="tableRight" v-if="Array.isArray(item.value)">
        <span
          v-for="(subItem, subIndex) in item.value"
          :key="subIndex"
          class="mark"
          >{{ subItem.name }}：{{ subItem.value }};</span
        >
      </div>
      <div
        :class="['tableRight', item.name === '事件编号' ? 'orange' : '']"
        v-else
      >
        {{ item.value }}
      </div>
    </div>
    <div class="tableRow">
      <div class="detailBox">
        <div class="header">督查详情</div>
        <div class="pics">
          <span class="name">现场照片:</span>
          <div class="tip" v-if="detaildata.imgurl === ''">暂无图片</div>
          <div
            v-else-if="
              detaildata.imgurl !== undefined && detaildata.imgurl !== ''
            "
            class="rightBlock"
          >
            <div class="img" v-for="(item, index) in srcList" :key="index">
              <el-image
                style="width: 100%; height: 100%"
                :src="item"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
          </div>
        </div>
        <div class="address">
          <span class="name">督查地点:</span>
          <span>{{ detaildata.conaddress }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuperviseArrangeDetail",
  props: {
    detailList: {
      type: Array,
      default: () => [],
    },
    detaildata: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    srcList() {
      return this.detaildataCopy.imgurl.split("|");
    },
  },
};
</script>

<style lang="less" scoped>
.superviseArrangeDetail {
  height: auto;
  overflow: scroll;
  padding: 30px 20px;
  .tableRow {
    display: flex;
    font-size: 15px;
    .tableRight {
      padding: 16px 0;
      width: 100%;
      color: #3b445a;
    }
    .tableLeft,
    .tableRight {
      min-height: 56px;
      padding-left: 12px;
      box-sizing: border-box;
      border: 1px solid #e2e5ec;
    }

    .tableLeft {
      width: 140px;
      color: #707b86;
      border-right: none;
      line-height: 56px;
      &:first-child {
        border-top: none;
      }
    }

    .tableRight {
      border-top: none;
    }
    .mark {
      margin-right: 8px;
      color: #009157;
    }
    .orange {
      color: #ff817e !important;
    }
    .detailBox {
      width: 100%;
      background: #f5f5f5;
      margin-top: 20px;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 8px 15px 8px 8px;
      .header {
        color: #707b86;
        margin-bottom: 10px;
        font-weight: 600;
      }
      .pics,
      .address {
        color: #707b86;
        margin-bottom: 6px;
        .tip {
          display: inline-block;
        }
        .rightBlock {
          display: inline-block;
          width: 76%;
          vertical-align: text-top;
          .img {
            display: inline-block;
            vertical-align: top;
            width: 46px;
            height: 35px;
            margin: 0 15px 10px 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .name {
          display: inline-block;
          margin-right: 10px;
        }
      }
    }
  }
  .tableRow:first-child {
    border-top: 1px solid #e2e5ec;
  }
}
</style>